import React from 'react';

import i18n from 'i18n-js';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import Box from '@material-ui/core/Box';
import Feature from 'components/Feature';
import Grid from '@material-ui/core/Grid';
import { useDispatch } from 'react-redux';
import useStyles from './Behaviour.styled';
import { SkusActions } from 'state/modules/skus';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import { TextField, SwitchField } from 'components/FormFields';
import { useSelector } from 'react-redux';

const SkuBehaviour = ({ formRef, errors, step }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const pricingConfig = useSelector((state) => state.config.settings?.core?.pricing || {});

  const initialValues = {
    automated: step?.automated || false,
    manually: step?.manually || !pricingConfig?.pricing_rules_set,
    default_unit_price: step?.default_unit_price || '',
  };

  const formSchema = Yup.object().shape({
    manually: Yup.boolean(),
    automated: Yup.boolean(),
    default_unit_price: Yup.string().when('manually', {
      is: true,
      then: Yup.string().required(i18n.t('common.required_field')),
    }),
  });

  const onSubmit = (values) => {
    let data = { ...values };

    // remove empty fields
    Object.keys(data).forEach((key) => !data[key] && data[key] !== false && delete data[key]);

    dispatch(SkusActions.fetchCreateSku(data));
  };

  return (
    <Box className={classes.container}>
      <Container className="h-100">
        <Grid
          container
          className={classes.container}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Formik
            initialValues={initialValues}
            validationSchema={formSchema}
            enableReinitialize={true}
            innerRef={formRef}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, values, setFieldValue }) => (
              <form noValidate onSubmit={handleSubmit} className={classes.formContainer}>
                <Feature name="pricing" is="pricing_rules_set">
                  <Typography variant="h6">
                    <Box fontWeight="400" fontSize={14} style={{ height: '100%' }}>
                      {i18n.t('skus.wizard.behaviour_title')}
                    </Box>
                  </Typography>

                  <Grid item xs={12} className={classes.rowContainer}>
                    <Grid item xs={10}>
                      <Typography variant="h6">
                        <Box fontWeight="fontWeightBold" fontSize={14} style={{ height: '100%' }}>
                          {i18n.t('skus.wizard.automated_sku_label')}
                        </Box>
                      </Typography>
                      <Typography variant="h6">
                        <Box
                          fontWeight="400"
                          fontSize={13}
                          style={{ height: '100%', opacity: 0.8 }}
                        >
                          {i18n.t('skus.wizard.automated_sku_description')}
                        </Box>
                      </Typography>
                    </Grid>

                    <Grid item xs={2}>
                      <Field
                        name="automated"
                        setFieldValue={setFieldValue}
                        color="primary"
                        component={SwitchField}
                      />
                    </Grid>
                  </Grid>
                </Feature>

                <Grid item xs={12} className={classes.rowContainer}>
                  <Grid item xs={10}>
                    <Typography variant="h6">
                      <Box fontWeight="fontWeightBold" fontSize={14} style={{ height: '100%' }}>
                        {i18n.t('skus.wizard.manually_sku_label')}
                      </Box>
                    </Typography>
                    <Typography variant="h6">
                      <Box fontWeight="400" fontSize={13} style={{ height: '100%', opacity: 0.8 }}>
                        {i18n.t('skus.wizard.manually_sku_description')}
                      </Box>
                    </Typography>
                  </Grid>

                  <Feature name="pricing" is="pricing_rules_set">
                    <Grid item xs={2}>
                      <Field
                        name="manually"
                        setFieldValue={setFieldValue}
                        color="primary"
                        component={SwitchField}
                      />
                    </Grid>
                  </Feature>
                </Grid>
                {(errors?.auto || errors?.manual) && !values?.automated && !values?.manually && (
                  <FormHelperText error={true}>{errors?.auto || errors?.manual}</FormHelperText>
                )}
                {values?.manually && (
                  <Grid item xs={6} className={classes.mt}>
                    <Field
                      name="default_unit_price"
                      margin={'none'}
                      format="price"
                      type="number"
                      label={i18n.t('skus.wizard.default_price')}
                      component={TextField}
                    />
                  </Grid>
                )}
              </form>
            )}
          </Formik>
        </Grid>
      </Container>
    </Box>
  );
};

export default SkuBehaviour;
